import { render, staticRenderFns } from "./BasicSearch.vue?vue&type=template&id=ae352824&scoped=true"
import script from "./BasicSearch.vue?vue&type=script&lang=js"
export * from "./BasicSearch.vue?vue&type=script&lang=js"
import style0 from "./BasicSearch.vue?vue&type=style&index=0&id=ae352824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae352824",
  null
  
)

export default component.exports